<template lang="pug">
v-btn(
  v-if="valid",
  color="secondary",
  @click="handler",
  rounded,
  depressed,
  x-small
) Adjust Price
</template>

<script>
import { EventBus } from "@/event-bus.js";

export default {
  props: ["order"],
  computed: {
    valid() {
      return this.order && this.order.status >= 0;
    },
  },
  methods: {
    async handler() {
      EventBus.$emit("adjust-price-order");
    },
  },
};
</script>

